import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    image: {
        imageRendering: '-webkit-optimize-contrast',
        objectFit: 'contain',
    }
});
